// Framework and third-party non-ui
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { MapContext } from "contexts/MapContext";
import AppStores from "configs/AppStores";
import AppPlaces from "configs/AppPlaces";

import "./WhereTo.css";

// JSON & Styles
import {
  StyledWhereTo,
  StyledSearchContainer,
  StyledFormControl,
  StyledQuickLinksContainer,
  StyledLink,
  StyledAppStoreFlex,
  StyledAppStoreLinksFlex,
  StyledAppStoreText,
  StyledAppleStore,
  StyledGooglePlay,
} from "./WhereTo-styled";

// Third-party components (buttons, icons, etc.)
import TrailSearch from "components/TrailSearch";
import { makeStyles } from "@material-ui/core/styles";

import Extent from "@arcgis/core/geometry/Extent";

// App components

import {
  getAllTrailFeaturesByTrailId,
  filterMapDataForTrailSelected,
  getAllNearbyTrails,
} from "data/map";

const APPLE_URL = AppStores.APPLE_STORE;
const GOOGLE_URL = AppStores.GOOGLE_PLAY;
const PLACES = AppPlaces.PLACES;

const WhereTo = () => {
  const { mapView, setSidebarSelection, ready } = useContext(MapContext);

  const useStyles = makeStyles((theme) => ({
    focusVisible: {
      color: "#1952EE",
      textDecoration: "underline",
    },
  }));

  const classes = useStyles();

  const history = useHistory();

  const getQuickLinks = () => {
    return PLACES.map((place, i) => {
      if (i < PLACES.length - 1) {
        return (
          <span key={place.name}>
            <StyledLink
              onClick={(e) => {
                goToLoc(e, place);
              }}
              classes={{
                focusVisible: classes.focusVisible,
              }}
              tabIndex={i + 4}
            >
              {place.name}
            </StyledLink>
            <span style={{ color: "#FFFFFF" }}>&nbsp;•&nbsp;</span>
          </span>
        );
      } else {
        return (
          <span key={place.name}>
            <StyledLink
              onClick={(e) => {
                goToLoc(e, place);
              }}
              classes={{
                focusVisible: classes.focusVisible,
              }}
            >
              {place.name}
            </StyledLink>
          </span>
        );
      }
    });
  };

  const goToLoc = async (e, place) => {
    e.preventDefault();
    if (place.type === "Trail") {
      const features = await getAllTrailFeaturesByTrailId(
        place.trailId,
        mapView.spatialReference
      );
      const nearbyFeatures = await getAllNearbyTrails(
        features[0].geometry,
        features[0].attributes.PRIMARY_TRAIL_ID
      );
      await filterMapDataForTrailSelected(features);
      mapView.when(function () {
        mapView.goTo({
          target: features[0], // Graphic object
          zoom: 15,
        });
      });
      setSidebarSelection([
        "Trail",
        features[0].attributes,
        nearbyFeatures,
        features[0],
      ]);
      // Update the route
    } else {
      mapView.goTo(
        new Extent(
          {
            xmin: place.location.xmin,
            ymin: place.location.ymin,
            xmax: place.location.xmax,
            ymax: place.location.ymax,
          },
          {
            duration: 1,
          }
        )
      );
      setSidebarSelection(null);
    }
    history.push("/details");
  };

  const handleEnter = (keyCode, fn) => {
    if (keyCode === 13) {
      fn();
    }
  };

  return (
    <StyledWhereTo data-testid="WhereTo">
      <h2>Where to?</h2>
      <StyledSearchContainer>
        <StyledFormControl>
          <TrailSearch inputWidth={"60ch"} tabIndex="4" />
          {/* <Button iconButton icon={<GpsOnIcon />} /> */}
        </StyledFormControl>
      </StyledSearchContainer>
      <StyledQuickLinksContainer>
        {ready ? getQuickLinks() : "Loading places... "}
      </StyledQuickLinksContainer>
      <StyledAppStoreFlex>
        <StyledAppStoreText>
          Experience your DE<b>TOUR</b> on the go.
        </StyledAppStoreText>
        <StyledAppStoreLinksFlex>
          <StyledAppleStore
            onClick={() => window.open(APPLE_URL, "_blank")}
            onKeyUp={(e) =>
              handleEnter(e.keyCode, () => window.open(APPLE_URL, "_blank"))
            }
            tabIndex="7"
            aria-label="Download App From Apple Store Link"
          />
          <StyledGooglePlay
            onClick={() => window.open(GOOGLE_URL, "_blank")}
            onKeyUp={(e) => {
              handleEnter(e.keyCode, () => window.open(GOOGLE_URL, "_blank"));
            }}
            tabIndex="8"
            aria-label="Download App From Google Play Store Link"
          />
        </StyledAppStoreLinksFlex>
      </StyledAppStoreFlex>
    </StyledWhereTo>
  );
};

export default WhereTo;
